// src/locales/en.js
import { common } from './en/common';
import { nav } from './en/nav';
import { auth } from './en/auth';
import { setup } from './en/setup';
import { dashboard } from './en/dashboard';
import { header } from './en/header';
import { sidebar } from './en/sidebar';
import { userRoles } from './en/userRoles';
import { users } from './en/users';
import { shops } from './en/shops';
import { warehouses } from './en/warehouses';
import { orders } from './en/orders';
import { ecomOrders } from './en/ecomOrders';
import { orderAssignment } from './en/orderAssignment';
import { forms } from './en/forms';
import { errors } from './en/errors';
import { footer } from './en/footer';
import { language } from './en/language';
import { business } from './en/business';
import { products } from './en/products';
import { productTags } from './en/productTags';
import { attributes } from './en/attributes';
import { categories } from './en/categories';
import { brands } from './en/brands';
import { couriers } from './en/couriers';
import { packingBatch, courierUpload, dispatch, print } from './en/packingBatch';
import { courierInvoice } from './en/courierInvoice';
import { returnBatch } from './en/returnBatch';
import { purchaseOrder } from './en/purchaseOrder';
import { stockAdjustment } from './en/stockAdjustment';
import { stockTransfer } from './en/stockTransfer';
import { report } from './en/report';
import { supplier } from './en/supplier';
import { subscription } from './en/subscription';
import { employeeCommission } from './en/employeeCommission';
import { phoneBlacklist } from './en/phoneBlacklist';
import { dropshipping } from './en/dropshipping';
import { pos } from './en/pos';
import { expenses } from './en/expenses';
import { profile } from './en/profile';
import { leadAutomation } from './en/leadAutomation';
import { messageCenterShifts } from './en/messageCenterShifts';
import { messageCenterShiftTypes } from './en/messageCenterShiftTypes';
import { messageCenterCommission } from './en/messageCenterCommission';
import { messageCenterShiftLeaderCommission } from './en/messageCenterShiftLeaderCommission';
import { paymentVerification } from './en/paymentVerification';
import { callCenterShifts } from './en/callCenterShifts';
import { callCenterCommission } from './en/callCenterCommission';
import { storePickup } from './en/storePickup';
import { offlineSales } from './en/offlineSales';
import { creditNote } from './en/creditNote';
import { quotation } from './en/quotation';
import { deliveryNote } from './en/deliveryNote';
import { returnNote } from './en/returnNote';
import { goodsReceivedNote } from './en/goodsReceivedNote';
import { returnToVendor } from './en/returnToVendor';
import { debitNote } from './en/debitNote';
import { procurement } from './en/procurement';

export default {
  common: common,
  nav: nav,
  auth: auth,
  setup:setup,
  dashboard: dashboard,
  header: header,
  sidebar: sidebar,
  userRoles: userRoles,
  users: users,
  shops: shops,
  warehouses: warehouses,
  orders: orders,
  ecomOrders: ecomOrders,
  orderAssignment: orderAssignment,
  products: products,
  productTags: productTags,
  attributes: attributes,
  categories: categories,
  brands: brands,
  forms: forms,
  errors: errors,
  footer: footer,
  language: language,
  business: business,
  couriers: couriers,
  packingBatch: packingBatch,
  dispatch:dispatch,
  print:print,
  courierUpload: courierUpload,
  courierInvoice: courierInvoice,
  returnBatch: returnBatch,
  purchaseOrder: purchaseOrder,
  stockAdjustment: stockAdjustment,
  stockTransfer: stockTransfer,
  report:report,
  supplier:supplier,
  subscription:subscription,
  employeeCommission:employeeCommission,
  phoneBlacklist:phoneBlacklist,
  dropshipping: dropshipping,
  pos: pos,
  expenses: expenses,
  profile: profile,
  leadAutomation: leadAutomation,
  messageCenterShifts: messageCenterShifts,
  messageCenterShiftTypes: messageCenterShiftTypes,
  messageCenterCommission: messageCenterCommission,
  messageCenterShiftLeaderCommission: messageCenterShiftLeaderCommission,
  paymentVerification: paymentVerification,
  callCenterShifts: callCenterShifts,
  callCenterCommission: callCenterCommission,
  storePickup: storePickup,
  offlineSales: offlineSales,
  creditNote: creditNote,
  quotation: quotation,
  deliveryNote: deliveryNote,
  returnNote: returnNote,
  goodsReceivedNote: goodsReceivedNote,
  returnToVendor: returnToVendor,
  debitNote: debitNote,
  procurement: procurement,
};